<template>
  <div class="login-container">
    <el-form ref="loginForm" class="login-form" auto-complete="on" label-position="left">
      <div class="title-container">
        <h3 class="title">
          Admin Login
        </h3>
      </div>
      <el-form-item>
        <span class="svg-container">
          <i class="material-icons">person_outline</i>
        </span>
        <el-input
            name="loginForm"
            v-model="loginForm.mb_id"
            type="text"
            auto-complete="on"
        />
      </el-form-item>

      <el-form-item>
        <span class="svg-container">
          <i class="material-icons loginForm">lock</i>
        </span>
        <el-input
            name="mb_password"
            v-model="loginForm.mb_password"
            :type="passwordType"
            auto-complete="on"
            @keyup.enter.native="userLogin"
        />
        <span class="show-pwd" @click="showPwd">
          <i class="material-icons loginForm">remove_red_eye</i>
        </span>
      </el-form-item>

      <el-button type="primary" style="width:100%;margin-bottom:30px;" @click="userLogin">
        Log in
      </el-button>
      <p class="copyright">Copyright Pinostory Corporation, All Right Recerved</p>
    </el-form>

  </div>
</template>

<script>
import Validator from "@/mixins/validator";
import VuxAlert from '@/mixins/vux-alert';
import sessionStorage from '@/mixins/sessionStorage';
import localStorage from '@/mixins/localStorage'


export default {
  name: "Login",
  mixins: [VuxAlert, Validator, sessionStorage, localStorage],
  data() {
    return {
      loginForm: {
        mb_id: '',
        mb_password: ''
      },
      passwordType: 'password',
      labelPosition: 'right',
      formLabelAlign: {
        name: '',
        region: '',
        type: ''
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    if ((to.path === "/method" || to.path === "/") && this.$route.query.logout) {
      next(false);
    } else {
      return next();
    }
  },

  methods: {

    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
    },

    async userLogin() {
      let params = {
        mb_id: this.loginForm.mb_id,
        mb_password: this.loginForm.mb_password,
        m_type: 'admin'
      };
      await this.$api.$auth.login(params)
          .then(res => res.Data.Result).then(res => {
            if (res.Info.Type === 1) {
              this.token = res.List;
              this.$localStorage.set('token', this.token);
              this.$api.$handler.authHeader(this.token);
              this.userInfo();
            } else { // 로그인 실패
              this.createAlert({
                title: "알림",
                content: "아이디 비번을 다시 확인해주세요.",
                btnText: "확인"
              });
            }
          });
      // }
    },
    async userInfo() {
      let UserInfo = {};
      let params = {m_type: 'admin', islist: 1}
      await this.$api.$user.getMemberList(params).then(res => res.Data.Result).then(res => {
        if (res.Info.Type === 1) {
          UserInfo = res.List[0].Member
          let UserAlarm = res.List[0].Alarm
          this.afterLogin({
            mb_id: UserInfo.mb_id,
            mb_no: UserInfo.mb_no,
            mb_name: UserInfo.mb_name,
            mb_hp: UserInfo.mb_hp,
            c_idx: 1,
            g_idx: UserInfo.g_idx,
            token: this.$localStorage.get('token'),
            mb_ad_alarm: UserAlarm.mb_ad_alarm,
            mb_alram: UserAlarm.mb_alram,
            first: false
          });
        } else {
          this.errorAlert(res.Info.reason);
          return false;
        }
      })
      this.$route.query.logout = false;
      if (UserInfo.g_idx == 7) {
        this.$router.push({path: "/nft/dash", query: {first: true}});
      } else {
        this.$router.push({path: "/member", query: {first: true}});
      }

    },

  }
}
</script>
